// Core
export const AUTH_KEY = "SOE_PORTAL_AUTH";
export const S3_BUCKET_LINK = "https://storage-soe.mof.gov.la/images/";
export const SOE_PREVIEW_URL = "https://soe.mof.gov.la/preview/";

// Chat
export const CHAT_ENDPOINT = "https://chat-api.lailaolab.com";
export const CHAT_SECRET_KEY = "5483b41601a96df7a6293de4739da862";
export const CHAT_BUCKET_LINK =
	"https://chat-api-bucket-lailaolab.s3.ap-southeast-1.amazonaws.com";
export const CHAT_FILE = `${CHAT_BUCKET_LINK}/images/`;

export const CHAT_AVATAR_EXTRA_SMALL = `${CHAT_BUCKET_LINK}/resized/avatars/extra-small/`;
export const CHAT_AVATAR_SMALL = `${CHAT_BUCKET_LINK}/resized/avatars/small/`;
export const CHAT_THUMBNAIL = `${CHAT_BUCKET_LINK}/resized/thumbnails/`;
export const CHAT_MEDIUM = `${CHAT_BUCKET_LINK}/resized/medium/`;
